export default "__VITE_ASSET__BB16c2_T__"